import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ScaleLoader } from 'react-spinners';

import Header from 'components/ui/Header';
import OCRTemplateApi from 'api/ocr-template';

import ImageMapper from 'components/ocr/ImageMapper';
import CanvasMapper from 'components/ocr/CanvasMapper';
import TemplateFieds from 'components/ocr/TemplateFieds';
import ContentSpinner from 'components/ui/ContentSpinner';

import NotificationHelper from '@youfy/shared/helpers/NotificationHelper';
import SubmitButton from 'components/ui/buttons/SubmitButton';

function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

const OCRTemplatePage = () => {
  const { templateId } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  let timer = null;

  useEffect(() => {
    fetchData(templateId);
  }, [templateId]);

  const fetchData = async templateId => {
    setLoading(true);
    try {
      const data = await OCRTemplateApi.get(templateId);
      data.items = data.items.map(i => {
        const fill = i.fill || getRandomColor();
        return { fill, ...i };
      });

      setData(data);
    } finally {
      setLoading(false);
    }
  };

  const mapper = new CanvasMapper();

  const onUpdated = () => {
    console.log('onUpdated');
  };

  const MainContent = () => {
    const [saving, setSaving] = useState(false);
    const [is_draft, setDraft] = useState(data.is_draft);

    const type = data.type || {};
    const type_items = type.items || [];

    const items = type_items.map(i => {
      const item = data.items.find(item => item.id === i.id) || {};
      const payload = { ...item.payload };

      delete item.template_id;
      delete item.created_at;
      delete item.updated_at;
      delete item.payload;

      const merged_item = {
        ...i,
        ...item,
        ...payload,
      };

      return merged_item;
    });

    const handleSave = async e => {
      e.preventDefault();
      setSaving(true);

      const items = mapper.getObjects();
      const name = document.querySelector('#input_name').value;
      const is_draft = document.querySelector('#isDraftInput').checked;

      const data = {
        name,
        items,
        is_draft,
      };

      try {
        await OCRTemplateApi.update(templateId, data);
        setDraft(is_draft);

        NotificationHelper.snack('OCR Template atualizado com sucesso.');
      } catch (error) {
        console.log(error);
        NotificationHelper.snack('Falha ao atualizar template.');
      } finally {
        setSaving(false);
      }
    };

    const DraftMessage = () => {
      if (is_draft) {
        return (
          <div className="alert alert-warning mt-3">
            <strong>Atenção:</strong> Este template está em modo rascunho. Não estará disponível para uso.
          </div>
        );
      }

      return null;
    };

    return (
      <div className="container" style={{ minWidth: 1280 }}>
        <DraftMessage />
        <div className="row mt-4">
          <div className="col-md-3">
            <input type="text" name="name" defaultValue={data.name} id="input_name" className="form-control form-control-lg" />

            <h6 className="mt-5">
              <small className="text-muted">CAMPOS</small>
            </h6>
            <hr className="mt-0 p-0" />

            <TemplateFieds items={type_items} mapper={mapper} />

            <div className="mt-5 row">
              <div className="col-md-4">
                <SubmitButton loading={saving} onClick={handleSave} className="btn btn-primary btn-lg">
                  Salvar
                </SubmitButton>
              </div>

              <div className=" col-md-8 mt-2">
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" defaultChecked={data.is_draft} role="switch" id="isDraftInput" />
                  <label className="form-check-label" for="isDraftInput">
                    Salvar como rascunho
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-9">
            <ImageMapper items={items} mapper={mapper} src={`https://s3.amazonaws.com/ocr.youfy.com.br/${data.id}.jpg`} onUpdated={onUpdated} />
          </div>
        </div>
      </div>
    );
  };

  const ContentRender = () => {
    if (!data.id || loading) {
      return (
        <div>
          <ContentSpinner />
        </div>
      );
    }

    if (data.status && data.status !== 'DONE') {
      clearTimeout(timer);
      timer = setTimeout(fetchData.bind(this, templateId), 10000);

      return (
        <div className="text-center mt-5">
          <div>Processando template. Isso pode demorar alguns minutos. Por favor, aguarde...</div>
          <div className="mt-4 text-center">
            <ScaleLoader size={100} />
          </div>
        </div>
      );
    }

    return <MainContent />;
  };

  return (
    <>
      <Header>
        <h1 className="m-0 p-0 fw-lighter">OCR Templates</h1>
      </Header>

      <ContentRender />
    </>
  );
};

export default OCRTemplatePage;
